export const objectMapper = (data: any[] | undefined, atribute: string) => {
  return data?.reduce(
    (acumulator: any, dataInfo: any) => ({
      ...acumulator,
      [dataInfo[atribute]]: dataInfo,
    }),
    {}
  );
};
